<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row justify="end" class="mr-0">
    <v-dialog persistent v-model="detailsItemDialog" max-width="600px">
<!--      <v-toolbar dark color="primary">-->
<!--        <v-toolbar-title class="headline"> {{$t('products_details')}}</v-toolbar-title>-->
<!--        <div class="flex-grow-1"></div>-->
<!--        <v-toolbar-items>-->
<!--          <v-btn icon dark @click="closeDialog">-->
<!--            <v-icon>mdi-close</v-icon>-->
<!--          </v-btn>-->
<!--        </v-toolbar-items>-->
<!--      </v-toolbar>-->
      <v-card v-if="detailsItemDialog">
        <v-card-text>
          <v-form ref="form" v-on:submit.prevent>
            <v-container class="pt-9" row justify-space-around>
              <v-col cols="12" mt-5>
                <v-row xs12 px-2>
                  <v-text-field readonly v-model="dataForModal.name"
                                :label="$t(translation+'.name')"
                  ></v-text-field>
                </v-row>
                <v-row xs12 px-2>
                  <v-text-field
                    readonly
                    v-model="dataForModal.description"
                    :label="$t('products.description')"
                    type="text"
                  ></v-text-field>
                </v-row>
                <v-row xs12 px-2>
                  <v-text-field
                    readonly
                    v-model="dataForModal.price"
                    :label="$t('products.price')"
                    type="text"
                  ></v-text-field>
                </v-row>
                <v-img
                  :src="'/api/images/products/'+dataForModal.image"
                  min-height="400px"
                ></v-img>
              </v-col>
              <v-col cols="7">
              </v-col>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text @click="closeDialog">{{$t('close')}}</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </v-row>
</template>


<script>
  import axios from 'axios';
  import {findById} from "../../statics/DataTableFunctions";

  export default {
    name: "ProductsDetails",
    props: {
      dataForModal: {},
      detailsItemDialog: false,
    },

    data() {
      return {
        translation: 'products',
        name:'',
        description:'',
        price:'',
        image: {
          path: ''
        },
      }
    },
    methods: {
      findById,
      readImage(){
        axios.get('images/products', this.lala).then(response => {
        }).catch(error => {

        })
      },
      closeDialog() {
        document.getElementsByClassName('v-dialog--active')[0].scrollTop = 0
        this.$emit('close', false)
      },
    },
    watch: {
      detailsItemDialog: function (val) {
        if (val) {
          this.name = this.dataForModal.name;
          this.description = this.dataForModal.description;
          this.price = this.dataForModal.price;
          this.image = {
            path: this.dataForModal.image,
          }
        }
      },
    },
  }
</script>


<style scoped>

</style>
